import * as React from 'react';

var DripServerError = function DripServerError() {
  return /*#__PURE__*/React.createElement("img", {
    src: "//img13.360buyimg.com/imagetools/jfs/t1/216634/18/18/40410/61653c39Efa46fdba/4cb84c1122d95805.png",
    width: "252",
    height: "147",
    alt: "500"
  });
};

export default DripServerError;